import React from 'react';
import { SlidersHorizontal, X } from 'lucide-react';

const FilterSelect = ({ label, value, options = [], onChange }) => (
    <div className="sd-filter-field">
        <label className="sd-filter-field__label">{label}</label>
        <select
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            className="sd-filter-field__select"
        >
            <option value="">All</option>
            {options.map((opt) => (
                <option key={opt.value} value={opt.value}>
                    {opt.label}
                </option>
            ))}
        </select>
    </div>
);

const FilterInput = ({ label, type, value, onChange, placeholder = 'Any' }) => (
    <div className="sd-filter-field">
        <label className="sd-filter-field__label">{label}</label>
        <input
            type={type}
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            className="sd-filter-field__input"
        />
    </div>
);

/**
 * SmartFilters - Compact expandable tab-specific metadata filters.
 */
const SmartFilters = ({
    activeTab,
    filters,
    countryOptions,
    onChange,
    onReset,
    isOpen,
    onToggle
}) => {
    const hasActiveSmartFilters =
        filters.gender ||
        filters.min_age ||
        filters.max_age ||
        filters.country_id ||
        filters.min_reactions ||
        filters.min_comments ||
        filters.visit_type;

    return (
        <div className="sd-smart-filters">
            <button
                onClick={onToggle}
                className={`sd-smart-filters__toggle ${isOpen || hasActiveSmartFilters ? 'sd-smart-filters__toggle--active' : ''}`}
            >
                <SlidersHorizontal size={14} />
                Filters
                {hasActiveSmartFilters && !isOpen && (
                    <span className="sd-smart-filters__badge">!</span>
                )}
            </button>

            {isOpen && (
                <div className="sd-smart-filters__panel">
                    <div className="sd-smart-filters__grid">
                        {activeTab === 'users' && (
                            <>
                                <FilterSelect
                                    label="Gender"
                                    value={filters.gender}
                                    options={[
                                        { value: 'male', label: 'Male' },
                                        { value: 'female', label: 'Female' }
                                    ]}
                                    onChange={(val) => onChange({ ...filters, gender: val })}
                                />
                                <FilterSelect
                                    label="Country"
                                    value={filters.country_id}
                                    options={countryOptions}
                                    onChange={(val) => onChange({ ...filters, country_id: val })}
                                />
                                <FilterInput
                                    label="Min Age"
                                    type="number"
                                    value={filters.min_age}
                                    onChange={(val) => onChange({ ...filters, min_age: val })}
                                />
                                <FilterInput
                                    label="Max Age"
                                    type="number"
                                    value={filters.max_age}
                                    onChange={(val) => onChange({ ...filters, max_age: val })}
                                />
                            </>
                        )}

                        {activeTab === 'social' && (
                            <>
                                <FilterInput
                                    label="Min Reactions"
                                    type="number"
                                    value={filters.min_reactions}
                                    onChange={(val) => onChange({ ...filters, min_reactions: val })}
                                />
                                <FilterInput
                                    label="Min Comments"
                                    type="number"
                                    value={filters.min_comments}
                                    onChange={(val) => onChange({ ...filters, min_comments: val })}
                                />
                            </>
                        )}

                        {activeTab === 'medical' && (
                            <>
                                <FilterSelect
                                    label="Visit Type"
                                    value={filters.visit_type}
                                    options={[
                                        { value: 'inpatient', label: 'Inpatient' },
                                        { value: 'outpatient', label: 'Outpatient' }
                                    ]}
                                    onChange={(val) => onChange({ ...filters, visit_type: val })}
                                />
                            </>
                        )}
                    </div>

                    <div className="sd-smart-filters__footer">
                        {hasActiveSmartFilters ? (
                            <span className="sd-smart-filters__status">
                                Filters active
                            </span>
                        ) : (
                            <span />
                        )}
                        <button
                            onClick={onReset}
                            className="sd-smart-filters__reset"
                        >
                            <X size={10} />
                            Reset
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SmartFilters;
